// planetFlightRandomizer.js
var PlanetFlightRandomizer = pc.createScript('planetFlightRandomizer');

PlanetFlightRandomizer.attributes.add('delayTime', { type: 'number', title: 'delayTime'});
PlanetFlightRandomizer.attributes.add('anm', { type: 'asset', title: 'animation'});

var theEnt;
var localAngles;
var theAnim;
var animName;

// initialize code called once per entity
PlanetFlightRandomizer.prototype.initialize = function() {
    theAnim = this.entity.animation;
    animName = this.anm.name;

    initRot = new pc.Vec3(Math.floor(Math.random()*360), Math.floor(Math.random()*360), Math.floor(Math.random()*360));
    theEnt = this.entity;
    localAngles = theEnt.getLocalEulerAngles();
    var dl = this.delayTime;
    var rndDl = Math.floor(Math.random()*dl);
    this.tweenTimer(dl);
};

PlanetFlightRandomizer.prototype.tweenTimer = function(dlt) {
    console.log("dlt" + dlt + " " + animName);
    theAnim.play(animName);
    var rX = Math.floor(Math.random()*360);
    var rY = Math.floor(Math.random()*360);
    var rZ = Math.floor(Math.random()*360);
    theEnt.tween(localAngles)
    .rotate({x: rX, y: rY, z: rZ}, 0.01, pc.Linear)
    .on('complete', function () {
        
    })
    .delay(dlt)
    .start();
};

// update code called every frame
PlanetFlightRandomizer.prototype.update = function(dt) {
    
};

// swap method called for script hot-reloading
// inherit your script state here
// PlanetFlightRandomizer.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

